import React from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = ({ 
    providers,
  totalEncounters, 
  signedEncounters, 
  unsignedEncounters, 
  nonduplicatePatcount, 
  CPTCount, 
  UnitCount,
  maxvalue
}) => {


  const adjustedMaxValue = Math.ceil(maxvalue / 50) * 50;
  const xTickAmount = adjustedMaxValue / 50;
  

  const chartData = {
    series: [
      { name: "Total Encounters", data: totalEncounters },
      { name: "Signed Encounters", data: signedEncounters },
      { name: "Unsigned Encounters", data: unsignedEncounters },
      { name: "Total Patients", data: nonduplicatePatcount },
      { name: "Total CPTs", data: CPTCount },
      { name: "Total Units", data: UnitCount },
    ],
    options: {
      chart: {
        type: "bar",
        height: 900, 
      },
      plotOptions: {
        bar: {
          horizontal: false, 
          columnWidth: "60%", 
          borderRadius: 5, 
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: true,
        position: "top",

      
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: providers,
     
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        title: {
          
        },
        min: 0,
        max: adjustedMaxValue, 
        tickAmount: xTickAmount, 
      },
      fill: {
        opacity: 1,
      },

      legend: {
        position: "top",
        fontSize: "18px",
      },

      tooltip: {
        enabled: true,
        followCursor: true, 
        y: {
          formatter: (val) => val,
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const value = series[seriesIndex][dataPointIndex];
          const seriesName = w.config.series[seriesIndex].name;
          return `<div style="padding: 8px; background: #fff; color: #000; border: 1px solid #ccc; border-radius: 4px;">
                    <strong>${seriesName}:</strong> ${value}
                  </div>`;
        },
     
      },
    },
  };

  return (
    <div style={{ width: "1500px", marginLeft: "200px", marginTop:'20px' }}> 
      <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={900} />
    </div>
  );
};

export default BarChart;
